import { webApiFetch, WebApiFetchConfig, webApiFetchInit } from './webApiFetch';

export const webTradingApiInit = (webApiUrl: string, webApiConfig?: WebApiFetchConfig) => webApiFetchInit(webApiUrl, webApiConfig);

export const webTradingApi = (webApiUrl: string) => webApiFetch(webApiUrl);

export { registerWebApiFetchUnauthorised as registerWebApiUnauthorised } from './webApiFetch';
